import { render, staticRenderFns } from "./ManageGridView.vue?vue&type=template&id=56d33163"
import script from "./ManageGridView.vue?vue&type=script&lang=js"
export * from "./ManageGridView.vue?vue&type=script&lang=js"
import style0 from "./ManageGridView.vue?vue&type=style&index=0&id=56d33163&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports